import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation, Trans } from 'react-i18next';

import { makeGetTheme } from '../selectors/app-props';
import { makeGetCurrentUser } from '../selectors/users';
import { makeGetSortedActiveTeams, makeGetCurrentTeam } from '../selectors/teams';
import { makeGetPanelNotificationsCount } from '../selectors/notifications';

import { updateCurrentUser } from '../actions/users';
import { showModal } from '../actions/modal';

import config from '../config';
import { trackEvent } from '../services/events-tracker-service';
import { featureAvailable } from '../services/features-service';
import { getSessionLength, logout, openIntercom } from '../globals-service';

import AppDropdown from 'components/AppDropdown';

import CanUser from './can-user';
import Popout from './popout';
import AvatarBase from './avatar-base';
import Tooltip from './tooltip';
import Select from './select';
import TeamsList from 'components/TeamsList';

import IconUpload from '../icons/icon-upload';
import IconPlus from '../icons/icon-plus';
import IconArrowDown from '../icons/icon-arrow-down';
import IconSun from '../icons/icon-sun';
import IconLink from '../icons/icon-link';

class SettingsCompact extends Component {
    state = {
        popoutVisible: false
    };

    handleToggleClick = () => {
        if (this.state.popoutVisible) {
            this.closePopout();
        } else {
            this.openPopout();
        }
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    openPopout() {
        this.popoutCtrl.show();
    }

    closePopout = () => {
        this.popoutCtrl.hide();
    }

    render() {
        if (!this.props.team) {
            return <div className="settings-compact" />
        }

        const { t } = this.props;

        return (
            <div className={'settings-compact' + (this.state.popoutVisible ? ' popout-visible' : '')}>
                <div className="settings-compact-main" onClick={this.handleToggleClick}>
                    <div className="image">
                        <AvatarBase size="small" text={this.props.team.initials} image={this.props.team.logo} color={this.props.team.color} foregroundColor={this.props.team.secondary_color} />
                    </div>

                    <div className="settings-compact-content">
                        <span className="title">{this.props.team.name}</span>

                        <span className="arrow">
                            <IconArrowDown />
                        </span>
                    </div>
                </div>

                <Popout
                    className="no-arrow dark settings-compact-popout"
                    xAlign="left"
                    resizeToFit={true}
                    provideController={ctrl => {this.popoutCtrl = ctrl}}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                >
                    <div className="popout-main">
                        <AppDropdown requestClose={this.closePopout} />
                    </div>
                </Popout>
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getCurrentTeam = makeGetCurrentTeam();
    const getSortedActiveTeams = makeGetSortedActiveTeams();
    const getPanelNotificationsCount = makeGetPanelNotificationsCount();
    const getTheme = makeGetTheme();

    return ({ teams, users, notifications, appProps }, ownProps) => {
        const team = getCurrentTeam(teams);
        return {
            team,
            teams: getSortedActiveTeams(teams.items),
            linkedTeams: teams.linkedTeams,
            currentUser: getCurrentUser(users),
            notificationsCount: getPanelNotificationsCount(notifications.items),
            theme: getTheme(appProps)
        }
    };
}

export default withRouter(connect(makeMapStateToProps)(withTranslation(['settings', 'common', 'billing', 'import', 'onboarding', 'team', 'notifications', 'apps', 'template'])(SettingsCompact)));
